import axios from "axios";

const rawBase =
  process.env.REACT_APP_API_URL ||
  "https://archkhanfarhan.pythonanywhere.com";

// Guard against malformed env values like "http://http://..."
export const API_BASE_URL = rawBase
  .replace(/^http:\/\/http:\/\//i, "http://")
  .replace(/^https:\/\/https:\/\//i, "https://")
  .replace(/\/$/, "");

export const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const adminAxios = axios.create({
  baseURL: `${API_BASE_URL}/api/admin`,
  headers: {
    "Content-Type": "application/json",
  },
});

adminAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("bcr_admin_access");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

adminAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config as any;
    if (
      error.response?.status === 401 &&
      original &&
      !original._retry &&
      localStorage.getItem("bcr_admin_refresh")
    ) {
      original._retry = true;
      try {
        const refresh = localStorage.getItem("bcr_admin_refresh");
        const { data } = await axios.post(
          `${API_BASE_URL}/api/admin/auth/refresh/`,
          { refresh }
        );
        localStorage.setItem("bcr_admin_access", data.access);
        original.headers.Authorization = `Bearer ${data.access}`;
        return adminAxios(original);
      } catch {
        localStorage.removeItem("bcr_admin_access");
        localStorage.removeItem("bcr_admin_refresh");
        localStorage.removeItem("bcr_admin_user");
        if (window.location.pathname.startsWith("/admin")) {
          window.location.href = "/admin/login";
        }
      }
    }
    return Promise.reject(error);
  }
);
